import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Link } from "react-router-dom";

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/shared/components/primitives/sidebar";

export type ColocaNavSecondaryItem = {
  to: string;
  label: string;
  icon?: ReactNode;
};

export function ColocaNavSecondary({
  items,
  activeTo = null,
  ...props
}: {
  items: ColocaNavSecondaryItem[];
  /** Same resolved answer the main nav gets, so the footer cannot disagree with it. */
  activeTo?: string | null;
} & ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const { isMobile, setOpenMobile } = useSidebar();
  // Same reason as ColocaNavMain: on mobile the sidebar is a Sheet over the page, and a tap inside it does not
  // dismiss it.
  const closeOnMobileNavigation = () => {
    if (isMobile) setOpenMobile(false);
  };
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.to}>
              <SidebarMenuButton
                isActive={item.to === activeTo}
                onClick={closeOnMobileNavigation}
                render={<Link to={item.to} />}
              >
                {item.icon}
                <span className="min-w-0 truncate">{item.label}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
